"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubStepMOTrads = void 0;
exports.ESubStepMOTrads = {
    draft: "Brouillon",
    processing: "À traiter",
    waiting_signature: "En attente de signature",
    waiting_contrepartie: "En attente de contrepartie",
    waiting_validation: "En cours de validation de la société de gestion",
    validated: "Validées",
    waiting_transfer_sg: "En attente de transfert à la société de gestion",
};
